import React, { useEffect, useState } from "react";
import TradingViewAdvancedChart from "./components/TradingViewAdvancedChart";
import { ChartFilterBar, ChartStyle } from "./components/ChartFilterBar";
import { getTVSymbol } from "../../../../../constants/TradingViewSymbols";

interface ChartsTabProps {
  baseCurrency: string;
  selectedStock: any;
}

export const ChartsTab: React.FC<ChartsTabProps> = ({ selectedStock }) => {
  const [isDark, setIsDark] = useState<boolean>(() => {
    return localStorage.getItem("darkMode") === "true";
  });
  const [studies, setStudies] = useState<string[]>([]);
  const [chartStyle, setChartStyle] = useState<ChartStyle>("1");
  const [compareSymbols, setCompareSymbols] = useState<string[]>([]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const tvSymbol = selectedStock?.ticker_symbol
    ? getTVSymbol(selectedStock.ticker_symbol)
    : "";

  return (
    <div className="flex md:flex-row flex-col items-center md:items-start w-full select-none">
      <div className="flex flex-col w-full h-full items-start px-4 py-3 mb-5">
        <div className="w-full" style={{ height: "calc(100vh - 250px)" }}>
          <ChartFilterBar
            onIndicatorsChange={setStudies}
            onChartStyleChange={setChartStyle}
            onCompareChange={setCompareSymbols}
            currentSymbol={tvSymbol}
          />
          <TradingViewAdvancedChart
            key={`${
              isDark ? "dark" : "light"
            }-${tvSymbol}-${chartStyle}-${studies.join(",")}-${compareSymbols.join(",")}`}
            symbol={tvSymbol}
            hideTopToolbar={true}
            allowSymbolChange={false}
            theme={isDark ? "dark" : "light"}
            backgroundColor={isDark ? "#0F0F0F" : "#FFFFFF"}
            studies={studies}
            chartStyle={chartStyle}
            compareSymbols={compareSymbols}
          />
        </div>
      </div>
    </div>
  );
};
